<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="d-flex align-items-center mb-2">
      <a class="link-secondary d-flex align-items-center cursor-pointer" (click)="location.back()">
        <svg class="icon icon-18 mr-1"><use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" /></svg>
        {{ 'trade.multi-order.confirm.back' | transloco }}
      </a>
    </div>
    @if (facade.multiOrderStrategy$ | async; as strategy) {
      <div class="tile p-0">
        @if (strategy.imageUrl) {
          <div class="image">
            <img [src]="imageBase + '/' + strategy.imageUrl" alt="strategy" />
          </div>
        }
        <div class="p-3">
          @if (strategy.headline) {
            <h3>{{ strategy.headline }}</h3>
          }
          <div class="mt-2 mb-0" [innerHTML]="strategy.text | markdown"></div>
          @if (strategy.assets?.length) {
            <div class="mt-4">
              <h3>{{ 'my-home.multi-order-strategies-details-page.assets.headline' | transloco }}</h3>
              <table aria-describedby="multi-order-strategy" class="table-depot">
                <thead>
                  <tr>
                    <th>{{ 'my-home.multi-order-strategies-details-page.assets.name' | transloco }}</th>
                    <th>{{ 'my-home.multi-order-strategies-details-page.assets.quote' | transloco }}</th>
                    <th>{{ 'my-home.multi-order-strategies-details-page.assets.change' | transloco }}</th>
                    <th>
                      @if (showCheckbox$ | async) {
                        {{ 'my-home.multi-order-strategies-details-page.assets.checkbox' | transloco }}
                      }
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (asset of strategy.assets; track asset.isin) {
                    <tr>
                      <td>
                        <web-components-instrument-details-link class="font-medium" [isin]="asset.isin">
                          {{ asset.longName }}
                        </web-components-instrument-details-link>
                      </td>
                      <td>{{ asset.quote?.ask | currency }}</td>
                      <td>
                        @if (asset.quote && asset.historicQuotes) {
                          @if ((asset.quote.ask / asset.historicQuotes[0].ask) * 100 - 100; as changeRelative) {
                            <div
                              [class.text-color-success]="changeRelative >= 0"
                              [class.text-color-error]="changeRelative < 0"
                              [zeroBlink]="true"
                              [val]="changeRelative"
                            >
                              {{ changeRelative | number: '1.2-2' }} %
                            </div>
                          } @else {
                            {{ 0 | number: '1.2-2' }} %
                          }
                        } @else {
                          &mdash;
                        }
                      </td>
                      <td>
                        @if (showCheckbox$ | async) {
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              [checked]="isins | includes: asset.isin"
                              [id]="asset.isin"
                              (change)="toggle($event, asset.isin)"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label cursor-pointer no-select" [for]="asset.isin"></label>
                          </div>
                        } @else {
                          <div class="d-flex justify-content-end">
                            <div
                              (click)="handleBuyButtonClick(strategy.id, asset.isin, $index)"
                              class="trade buy small cursor-pointer ml-3"
                            >
                              K
                            </div>
                          </div>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          <div class="row">
            <div class="col d-flex justify-content-end">
              @if (hasCta$ | async) {
                <web-design-system-button (click)="handleCtaButtonClick(strategy.cta)">
                  {{ strategy.cta.text | uppercase }}
                </web-design-system-button>
              } @else if (strategy.assets?.length) {
                <web-design-system-button [disabled]="!isins.length" (click)="handleMultiorderButtonClick(strategy.id)">
                  @if (strategy.cta?.text) {
                    {{ strategy.cta.text | uppercase }}
                  } @else if (!isins.length || isins.length === 1) {
                    {{ 'my-home.multi-order-strategies-details-page.btn.single' | transloco | uppercase }}
                  } @else {
                    {{ isins.length }} {{ 'my-home.multi-order-strategies-details-page.btn.multi' | transloco | uppercase }}
                  }
                </web-design-system-button>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
